import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12.002 8.126a.763.763 0 0 1 .424.131.748.748 0 0 1 .106.089l-.079-.07a.752.752 0 0 1 .007.006l.072.064 3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.471-2.47v10.69a.75.75 0 0 1-.648.743l-.101.007a.75.75 0 0 1-.75-.75l-.001-10.69-2.469 2.47a.75.75 0 0 1-.977.073l-.084-.073a.75.75 0 0 1 0-1.06l3.75-3.75.072-.064a.754.754 0 0 1 .459-.156l-.074.003a.754.754 0 0 1 .044-.003zM17 1.876a3.25 3.25 0 0 1 3.25 3.25V15.75A3.25 3.25 0 0 1 17 19h-1.875a.75.75 0 1 1 0-1.5H17a1.75 1.75 0 0 0 1.75-1.75V5.126A1.75 1.75 0 0 0 17 3.376H7a1.75 1.75 0 0 0-1.75 1.75V15.75c0 .966.784 1.75 1.75 1.75h1.877a.75.75 0 1 1 0 1.5H7a3.25 3.25 0 0 1-3.25-3.25V5.126A3.25 3.25 0 0 1 7 1.876z' />
  </svg>
);
